import * as React from "react";

function Landing() {
  return (
    <div className="flex flex-col justify-center w-full text-white">
      <div
        className={`flex overflow-hidden relative flex-col items-center px-6 md:px-8 lg:px-10 pt-6 pb-14 w-full banner_container lg:min-h-[calc(100vh-100px)] max-md:px-5 max-md:max-w-full`}
      >
        <img
          loading="lazy"
          src={
            window.location.pathname.includes("career")
              ? "/nirantara-career-banner.jpg"
              : process.env.PUBLIC_URL + "/assets/images/certification.png"
          }
          alt="Career Banner"
          style={{ filter: "brightness(50%)" }}
          className="absolute inset-0 object-cover size-full"
        />
        <h5 className="absolute font-bold text-5xl md:text-8xl text-center text-white bottom-[30%] left-1/2 -translate-x-1/2 whitespace-pre-line uppercase !leading-[1.3] w-full">
          CAREERS
        </h5>
      </div>

      {/* Introduction Section */}
      {/* <div className="flex flex-col px-4 text-5xl font-semibold text-black md:px-20 max-md:text-4xl">
        <h1 className="mt-16 font-semibold text-left text-black uppercase lg:text-5xl helvetica" >
          BE THE FORCE OF CHANGE THAT MAKES AN IMPACT{" "}
        </h1>

        <p className="w-full mt-6 text-lg font-light leading-9 text-black max-md:max-w-full">
          At Nirantara, work is more than just a task; it’s a journey of growth and impact.
          Our strong work ethic and robust processes provide a deep sense of satisfaction,
          knowing we contribute to the global sustainability agenda.
        </p>
        <p className="w-full mt-6 text-lg font-light leading-9 text-black max-md:max-w-full">
          We are building a robust resource base to support enterprises across India’s
          industrial belts, fostering impactful change while advancing careers in the
          fast-evolving field of ESG and sustainability.
        </p>
        <p className="w-full mt-6 text-lg font-light leading-9 text-black max-md:max-w-full">
          Join us to embark on a rewarding journey towards building a sustainable future.
        </p>
      </div> */}


    </div>
  );
}

export default Landing;
